import * as React from "react"
import { CarouselSeeker } from "@ui-seeker/core"

import { stockCarouselMove } from "../@signals"


export default function SkuDetailsStockCarousel({ children, ...props }) {

	return <CarouselSeeker 
        responsive={{ desktop: { items: 2 } }} 
        centerMode
        afterChange={() => stockCarouselMove.value = false}
        beforeChange={() => stockCarouselMove.value = true}
        {...props}
    >
        { children }
    </CarouselSeeker>
}